const BasicData={
    moveSpeedFactor:1.4,//横向滚动速度
    inertiaTime:"0.5s",//滚动的滑行时间
    startInertiaTime:"0.3s",//开场动画的滑行时间
    mobileBlurTime:"0.5s",//手机版的模糊时间
    PCBlurTime:"1s",
    mobileOrPC:820
}
export default BasicData
